import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import { Button } from 'web-makeup/dist/design-system/button'

import { SMALL_BREAKPOINT, XSMALL_BREAKPOINT } from '../../../../style'

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: block;

    input,
    label {
      width: 100%;
    }

    button {
      position: fixed;
      bottom: 20px;
      z-index: 9;
      left: 20px;
    }
  }

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    padding-top: 1.5rem;
  }
`
export const StyledInput = styled.input`
  background: white;
  border: 1.5px solid ${colors.radagast};
  box-sizing: border-box;
  border-radius: 100px;
  height: 2.75rem;
  width: 15.5rem;
  max-width: 100%;
  padding: 0 2rem 0 2.5rem;
  color: ${colors.black1};
  outline: none;
  transition: all 0.3s ease;

  &::placeholder {
    color: ${colors.saruman};
    opacity: 1;
  }

  /* stylelint-disable */
  &:-ms-input-placeholder {
    color: ${colors.saruman};
  }

  &::-ms-input-placeholder {
    color: ${colors.saruman};
  }
  /* stylelint-enable */

  &.filled {
    border-color: ${colors.black1};
  }

  &:focus {
    border-color: ${colors.black1};
  }
`
export const StyledLabel = styled.label`
  position: relative;
  display: inline-block;

  > picture {
    position: absolute;
    top: 0.7rem;
    left: 1rem;
  }

  img {
    width: 1rem;
    height: 1rem;
  }
`
export const StyledButton = styled(Button)`
  &&&,
  &&&:hover,
  &&&:focus,
  &&&:active {
    border-color: ${colors.adaptBlue};
    color: white;
    font-size: 14px;
    font-weight: 600;
    padding: 0 1.375rem 0 2.6875rem;
    height: 2.75rem;
    border-radius: 100px;
    background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1582007368/-design-system/icon-add-white.svg)
      no-repeat ${colors.adaptBlue};
    background-position: 20px center;
  }
`
export const CloseButton = styled.div`
  background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1598579444/icons/icon-remove.svg)
    no-repeat center;
  width: 1.5rem;
  height: 1.5rem;
  position: absolute;
  top: 0.625rem;
  right: 0.75rem;
  cursor: pointer;
`
export const ButtonWrapper = styled.div<{ hide?: boolean }>`
  position: relative;
  z-index: 24;
  ${({ hide }) => hide && 'display: none;'};
`
export const OptionButton = styled.div`
  height: 2.25rem;
  padding: 0 0.75rem;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1rem;
  border-radius: 0.375rem;
  border: 1px solid #e9e9e9;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  color: ${colors.black1};
  cursor: pointer;
  z-index: 1;

  svg {
    margin-right: 0.375rem;
  }

  &.active {
    background: ${colors.black1};
    border-color: ${colors.black1};
    color: white;

    svg {
      fill: white;
    }
    path {
      fill: white;
    }
  }
`
export const OptionDropdown = styled.div`
  position: absolute;
  border-radius: 0.5rem;
  background: white;
  padding: 0.56rem 0.75rem;
  top: 2.75rem;
  right: 0;
  width: 8.5rem;

  li {
    margin-bottom: 0.625rem;
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1.375rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  label {
    display: flex;
    align-items: center;
    cursor: pointer;

    input {
      margin-right: 0.5rem;
      accent-color: ${colors.adaptBlue};

      &:hover {
        accent-color: ${colors.adaptBlue};
        filter: brightness(1.4);
      }
    }
  }
`

export const StatusButton = styled(OptionButton)`
  background: none;
  border: none;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  line-height: 1.5rem;
  font-weight: 700;
  height: 2.25rem;

  svg {
    margin-left: 0.5rem;
  }

  &.active {
    color: ${colors.black1};
    background: none;
    border: none;

    svg {
      transform: rotate(180deg);
      fill: ${colors.black1};
    }
    path {
      fill: ${colors.black1};
    }
  }
`

export const FiltersWrapper = styled.div`
  display: flex;
  align-items: center;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    margin-top: 1rem;
  }
`
export const FilterButton = styled.div`
  cursor: pointer;
  color: rgb(53, 53, 58);
  list-style: none;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.125rem;
  margin-left: 0.75rem;
  height: 1.875rem;
  display: flex;
  align-items: center;
  padding: 0px 0.75rem;
  white-space: nowrap;

  &.active {
    color: white;
    background: rgb(53, 53, 58);
    border-radius: 0.5rem;
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    margin-bottom: 0.5rem;
  }
`
export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-flow: row wrap;
`
export const MainFlexWrapper = styled(FlexWrapper)`
  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    flex-direction: column;
    align-items: flex-end;

    label {
      margin-bottom: 1rem;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/SearchSection/search-section.style.ts